import { render, staticRenderFns } from "./tab-layout.vue?vue&type=template&id=777b5f28"
import script from "./tab-layout.vue?vue&type=script&lang=js"
export * from "./tab-layout.vue?vue&type=script&lang=js"
import style0 from "./tab-layout.vue?vue&type=style&index=0&id=777b5f28&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports